export default __webpack_public_path__ + "static/media/img-0067-uk-full-face.1ff8d428.png";